import { combineReducers } from 'redux'

import entities from './entities/entitiesReducer'
import lists from './lists/listsReducer'

export const appReducer = combineReducers({
  entities,
  lists,
})
